import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { LuAlignJustify } from 'react-icons/lu';

import { LEAD_LIST_DEFAULT_FILTERS } from '~/constants';

const Summary = () => {
    const { t } = useTranslation();
    return (
        <Link
            to="/leads"
            search={LEAD_LIST_DEFAULT_FILTERS}
            activeOptions={{ includeSearch: false }}
            className="flex items-center px-2 py-1 gap-2 text-sm rounded transition-all"
            inactiveProps={{ className: 'text-white hover:bg-white hover:text-[#1e2b43]' }}
            activeProps={{ className: 'bg-white text-[#1e2b43]' }}
        >
            <>
                <LuAlignJustify />
                <span>{t('TOP_HEADER.NAV_BAR.SUMMARY')}</span>
            </>
        </Link>
    );
};

export default Summary;
